var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardWidgetBarStack',{staticClass:"widget-andamento-vendite",attrs:{"title":"Andamento delle Vendite","dataY":_vm.dataY,"dataX":_vm.dataX,"legendData":_vm.legendData}})}
var staticRenderFns = []

export { render, staticRenderFns }